import React, { forwardRef, useState } from "react";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";
import PropTypes from "prop-types";
import classNames from "classnames";

import Typography from "../Typography/Typography";

import styles from "./Checkbox.module.scss";
import { handleKeyDownSelectItem } from "../../utils/keyboard-navigation/keyboard-navigation";

const Checkbox = forwardRef(({
  className, iconClassName = "",
  style,
  isInline,
  isTranslateLabel,
  checked, partCheck, disabled,
  title,
  onChange,
  typographyProps,
  slotBefore,
  groupName,
  isFocusable = true,
}, ref) => {
  const { t } = useSharedTranslation();

  const name = (groupName ?? "checkbox") + "" + title;

  const [focus, setFocus] = useState(false);

  const isCheckboxChecked = partCheck || checked;

  const handleKeyDown = (event) => {
    if (onChange) {
      handleKeyDownSelectItem(event, (e) => onChange(!isCheckboxChecked, e));
    }
  };

  return (
    <div
      ref={ref}
      style={style}
      onClick={(e) => onChange && onChange(!isCheckboxChecked, e)}
      className={classNames(styles["checkbox-item"], "checkbox-item", className, {
        [styles["focused"]]: focus,
        [styles["checked"]]: checked && !partCheck,
        [styles["part-checked"]]: partCheck,
        [styles["is-inline"]]: isInline,
        [styles["disabled"]]: disabled,
      })}
    >
      {slotBefore}
      <input
        tabIndex={isFocusable ? 0 : -1}
        data-focus={isFocusable ? undefined : "false"}
        type="checkbox"
        name={name}
        className={styles["input"]}
        checked={isCheckboxChecked}
        onChange={() => {}}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        onKeyDown={handleKeyDown}
      />
      <div className={classNames(styles["wrap-checkmark"], "global_wrap-checkmark", iconClassName)}>
        <div className={styles["checkmark"]} />
      </div>
      {title && <Typography
        tag="label"
        htmlFor={name}
        // threeDots
        variant="body3"
        className={styles["label"]}
        color="inherit"
        {...typographyProps}
      >{isTranslateLabel ? t(title) : title}</Typography>}
    </div>
  );
});

Checkbox.propTypes = {
  title: PropTypes.string,
  checked: PropTypes.bool,
  isInline: PropTypes.bool,
  disabled: PropTypes.bool,
  partCheck: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  typographyProps: PropTypes.object
};

export default Checkbox;
